import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Home, Mic, Sparkles, BarChart3 } from 'lucide-react';
import Logo from './brand/Logo';

const NAV = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/practice', label: 'Practice', icon: Mic },
  { to: '/accent-test', label: 'Accent test', short: 'Accent', icon: Sparkles },
  { to: '/dashboard', label: 'Progress', icon: BarChart3 },
];

// Desktop: sticky top bar. Mobile: slim top bar + a bottom tab bar, so the
// four destinations stay under the thumb.
const Navbar = () => (
  <>
    <header
      className="sticky top-0 z-40 border-b border-white/[0.06] bg-ink-950/70 backdrop-blur-xl"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
        <Link to="/" aria-label="Cadenza home" className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-1 rounded-full border border-white/[0.07] bg-white/[0.03] p-1 md:flex" aria-label="Main">
          {NAV.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? 'bg-white/10 text-white' : 'text-white/60 hover:text-white'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <Link to="/accent-test" className="cz-btn-primary hidden !px-4 !py-2 text-sm md:inline-flex">
          Guess my accent
        </Link>
      </div>
    </header>

    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/[0.07] bg-ink-950/85 backdrop-blur-xl md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Main"
    >
      <div className="mx-auto grid max-w-md grid-cols-4">
        {NAV.map(({ to, label, short, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                isActive ? 'text-white' : 'text-white/45'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`grid h-8 w-12 place-items-center rounded-full transition-colors ${isActive ? 'bg-brand-500/20 text-brand-300' : ''}`}>
                  <Icon className="h-[19px] w-[19px]" />
                </span>
                {short || label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  </>
);

export default Navbar;
